<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="form" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem label="参数域:" prop="namespace">
          <Select
            v-model="formFields.namespace"
            size="small"
            placeholder="请选择参数域..."
            clearable
            filterable
          >
            <Option v-for="(option, index) in namespaceOptions" :key="index" :value="option.value" :label="option.label" />
          </Select>
        </FormItem>
        <FormItem label="参数名:" prop="description">
          <Input v-model="formFields.description" placeholder="请输入参数名..." size="small" />
        </FormItem>
        <FormItem label="参数Key:" prop="key">
          <Input v-model="formFields.key" placeholder="请输入参数Key..." size="small" />
        </FormItem>
        <FormItem label="参数默认值:" prop="value">
          <Input v-model="formFields.value" placeholder="请输入参数默认值..." size="small" />
        </FormItem>
        <input v-model="formFields.id" type="hidden" name="id"></input>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'ConfigDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      submit: false,
      formFields: {
        namespace: '',
        key: '',
        value: '',
        description: '',
        id: this.id
      },
      ruleValidate: {
        description: [
          { required: true, message: '参数名不能为空!', trigger: 'blur' }
        ],
        key: [
          { required: true, message: '参数Key不能为空!', trigger: 'blur' }
        ],
        value: [
          { required: true, message: '参数默认值不能为空!', trigger: 'blur' }
        ],
        namespace: [
          { required: true, message: '参数域不能为空!' }
        ]
      }
    }
  },
  computed: {
    namespaceOptions() {
      return [
        { label: '终端配置', value: 'NS_AGENT' },
        { label: '车库配置', value: 'NS_PARKING' },
        { label: '车辆配置', value: 'NS_VEHICLE' },
        { label: '会员配置', value: 'NS_MEMBER' },
        { label: '产品配置', value: 'NS_PRODUCT' },
        { label: '系统配置', value: 'NS_SYSTEM' }
      ]
    },
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑数据字典' : '添加数据字典'
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
      this.loadingStatus = false
      if (this.action && this.id) {
        this.loadingStatus = true
        request({
          url: this.action + '/' + this.id,
          method: 'get'
        }).then(res => {
          this.loadingStatus = false
          this.formFields = res.data
        }).catch(() => {
          // this.$Notice.error({
          //   title: '服务器数据请求失败',
          //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
          // })
          this.loadingStatus = false
        })
      }
    }
  },
  methods: {
    resetForm: function() {
      this.$refs.form.resetFields()
      this.formFields.id = 0
    },
    saveOrUpdate: function() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.action) {
            this.$refs.form.validate((valid) => {
              if (valid) {
                this.submit = true
                const isNew = this.formFields.id === 0
                request({
                  url: this.action + (isNew ? '' : ('/' + this.id)),
                  method: isNew ? 'POST' : 'PUT',
                  data: this.formFields
                }).then(res => {
                  this.loadingStatus = false
                  this.formFields = res.data
                  this.$Notice.success({
                    title: '数据字典 `' + this.formFields.name + '` 保存成功!'
                  })
                  this.submit = false
                  this.closeModal(true)
                }).catch(() => {
                  // this.$Notice.error({
                  //   title: '服务器数据请求失败',
                  //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
                  // })
                  this.loadingStatus = false
                  this.submit = false
                })
              }
            })
          }
        }
      })
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>

